(function ($, Global) {
	var ArticlesComponent = function (model) {
		this.model = model;
	};

	ArticlesComponent.prototype.initEvents = function () {
		this.publishers();
	}

	ArticlesComponent.prototype.publishers = function () {
		var self = this;

		$(document).on('click', 'article.collapse a[href]', function (e) {
			e.stopPropagation();
		});

		$(document).on('click', 'article.collapse.show', function (e) {
            e.preventDefault();

            var $this = $(this);
		    var isZenMod = $(this).closest('.zen-content').exists();
			var articleState = $this.hasClass('integral') ? 'integral' : 'preview';
			var articleId = $this.attr('data-article');
            var data = articleId;

            $.Topic('loader-show').publish($this);

			if ($this.find('.article-content.integral').length == 0) {
				self.model.display(data, function (data) {
					var content = createArticleContent(data.data.html);

					$this.append(content);
					$('[data-toggle="popover"]').popover();
                    self.goArticleInIntegral($this);

                    if (isZenMod && Global.dataLayer) {
                        Global.dataLayer.push({
                            'event': 'VirtualPageview',
                            'virtualPageURL': data.data.url,
                            'virtualPageTitle': 'Lecture Fluide'
                        });
                    }
				})
			} else {
				self.changeArticleState($this, articleState);
			}
        });       

        $(document).on('mouseenter', 'article.read', function () {
            var isIntegralMod = $(this).hasClass('integral');

            if (!isIntegralMod) $(this).find('.icon-7[data-toggle="tooltip"]').tooltip('show');
        });

        $(document).on('mouseleave', 'article.read', function () {
            var isIntegralMod = $(this).hasClass('integral');

            if (!isIntegralMod) $(this).find('.icon-7[data-toggle="tooltip"]').tooltip('hide');
        });
	}

	ArticlesComponent.prototype.goArticleInPreview = function ($el) {
		var self = this;

		return $el.collapse('hide')
			.replaceClass('integral', 'preview')
			.on('hidden.bs.collapse', function () {
				self.showArticle($el);
			});
	}

	ArticlesComponent.prototype.goArticleInIntegral = function ($el) {
        var self = this;

        $('.icon-7[data-toggle="tooltip"]').tooltip('hide');

		return $el.collapse('hide')
			.replaceClass('preview', 'integral')
			.on('hidden.bs.collapse', function () {
				self.showArticle($el, true);
			});
	}

	ArticlesComponent.prototype.changeArticleState = function ($el, state) {
		if (state == 'preview') {
			return this.goArticleInIntegral($el);
		} else {
			return this.goArticleInPreview($el);
		}
	}

	ArticlesComponent.prototype.showArticle = function ($el, scrolling) {
        $el.collapse('show');
        $.Topic('loader-hide').publish($el);
	}

	function createArticleContent(html) {
		var elemArticleContent = $('<div class="article-content integral"></div>');

		elemArticleContent.html(html);
		return elemArticleContent;
	}

	function getTitleTag() {
		var $page = $('.page');

		if ($page.hasClass('page-archives')) {
			return 'h2';
		} else {
			return 'h3';
		}
	}

	Global.ArticlesComponent = ArticlesComponent;
}(jQuery, window));